import api from "../../../../api/api";

/** PL / Platform List */
export const getPLList = (verticalId: number) => {
  return api.get(`/hr/v1/platforms/?vertical_id=${verticalId}`);
};

export const getChannelList = (params?: { page?: number }) => {
  return api.get("/crm/v1/channel-master/", { params });
};

export const getResponsibleUsers = (params: {
  vertical_id: number;
  stage_id?: number;
  exclude_role?: string;
  bulk_transfer?: boolean;
}) => {
  return api.get("/crm/v1/responsible-user/", {
    params,
  });
};

export const getResponsibleUsersByStage = (
  verticalId: number,
  stageId?: number
) => {
  let url = `/crm/v1/responsible-user/?vertical_id=${verticalId}`;

  if (stageId) {
    url += `&stage_id=${stageId}`;
  }

  return api.get(url);
};

export const getInquirySourceList = () => {
  return api.get("/crm/v1/source/");
};
export const createInquiry = (payload: any) => {
  return api.post("/crm/v1/post-enquiry/", payload, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
export const getInquiryById = (id: number) => {
  return api.get(`/crm/v1/auto-fetch-enquiry/${id}/`);
};

/* ================= UPDATE INQUIRY ================= */
export const updateInquiryDetails = (id: number, payload: any) => {
  return api.patch(`/crm/v1/update-enquiry/${id}/`, payload);
};
/* ================= UPLOAD INQUIRY DOCUMENTS ================= */
// export const uploadInquiryDocuments = (id: number, formData: FormData) => {
//   return api.patch(`/crm/v1/update-enquiry/${id}/`, formData,  {
//     headers: {
//       "Content-Type": "multipart/form-data",
//     },
//   });
// };



/* ================= ACTIVITY LOG ================= */
export const createInquiryActivity = (payload: any) => {
  return api.post("/crm/v1/enquiry-activity-logs/", payload);
};
export const getProbabilityList = () => {
  return api.get("/crm/v1/probability-master/");
};
export const getInquiryList = (
  page: number,
  verticalId: number,
  params: any = {}
) => {
  return api.get("/crm/v1/glazing-enquiry/", {
    params: {
      page,
      vertical: verticalId, // ✅ THIS WAS MISSING
      ...params,
    },
  });
};
export const getStageListForInquiry = (params?: { page?: number }) => {
  return api.get("/crm/v1/stage-master/", { params });
};
export const getClientSegmentByVertical = (verticalId: number) => {
  return api.get("/hr/v1/client-segment-master/", {
    params: { vertical_id: verticalId },
  });
};


export const getInquiryActivityLogs = (enquiryId: number) => {
  return api.get(
    `/crm/v1/enquiry-activity-logs/by-enquiry/${enquiryId}/`
  );
};

export const uploadInquiryDocuments = (
  inquiryId: number,
  documents: {
    file: File;
    description: string;
  }[]
) => {
  const formData = new FormData();

  documents.forEach((doc) => {
    formData.append("documents", doc.file);
    formData.append("description", doc.description || "");
  });

  return api.post(
    `/crm/v1/enquiry/${inquiryId}/documents/`,
    formData
  );
};

export const replaceInquiryDocument = (
  documentId: number,
  file: File
) => {
  const formData = new FormData();
  formData.append("document", file);

  return api.post(
    `/crm/v1/enquiry-document/${documentId}/replace/`,
    formData
  );
};

export const deleteInquiryDocument = (documentId: number) => {
  return api.delete(
    `/crm/v1/enquiry-document/${documentId}/`
  );
};

export const deleteInquiry = (id: number) => {
  return api.delete(`/crm/v1/delete-enquiry/${id}/`);
};

export const getRecycleBinEnquiries = (params?: { vertical?: number }) => {
  return api.get("/crm/v1/recycle-bin-enquiry/", { params });
};

export const restoreInquiry = (id: number) => {
  return api.patch(`/crm/v1/restore-enquiry/${id}/`);
};

export const permanentDeleteInquiry = (id: number) => {
  return api.delete(`/crm/v1/permanent-delete-enquiry/${id}/`);
};

export const listInquiryDocuments = (inquiryId: number) => {
  return api.get(
    `/crm/v1/enquiry-document/${inquiryId}/documents/`
  );
};
export const saveWonPaymentTerms = (payload: {
  enquiry_id: number;
  skip_payment_terms: boolean;
  quotation_amount?: number;   // ⭐ ADD THIS
  payment_terms: { term_id: number; amount: number }[];
}) => {
  return api.post("/crm/v1/save-won-payment-terms/", payload);
};

export const getEnquiryPaymentTerms = (enquiryId: number) => {
  return api.get(`/crm/v1/enquiry-payment-terms/?enquiry_id=${enquiryId}`);
};